<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCondicionContrato" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <label for="idioma">Idioma:</label>
                            <select class="form-control form-select" v-model="objCondicionContrato.Idioma">
                                <option value="">Seleccione una opción</option>
                                <option v-for="(item, index) in Idiomas" :key="index" :value="item.Lang">{{ item.Nombre }}</option>
                            </select>
                            <CValidation v-if="this.errorvalidacion.Idioma" :Mensaje="'*' + errorvalidacion.Idioma[0]"/>
                        </div>
                    </div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Descripcion">Descripción</label>
                            <textarea v-model="objCondicionContrato.Descripcion" class="form-control" id="Descripcion" placeholder="Ingresar Descripción" rows="5"></textarea>
							<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
						</div>
					</div>
									
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCondicionContrato',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCondicionContrato: {
				IdCondicionCont: 0,
				Descripcion: '',
                Idioma: '',
				IdEmpresa: 0,
				IdSucursal: 0,
            },
            Idiomas:[
                {
                    Lang:'ES',
                    Nombre:'Español'
                },
                {
                    Lang:'EN',
                    Nombre:'Inglés'
                }
            ],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCondicionContrato.IdCondicionCont == 0) {
				await this.$http.post(
					'condicionesContrato',this.objCondicionContrato
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'condicionesContrato/'+this.objCondicionContrato.IdCondicionCont,
					this.objCondicionContrato
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "condicionesContrato/"+this.objCondicionContrato.IdCondicionCont
            ).then((res) => {
                this.objCondicionContrato = res.data.data;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCondicionContrato = {
				IdCondicionCont: 0,
				Descripcion: '',
                Idioma: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCondicionContrato.IdCondicionCont = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
